/**
 * @generated SignedSource<<59d4f5b78a47dd2bb7967ad845fe17db>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type IfpIneligibleLineReason = "GRANDFATHERED" | "IFP_LIMIT" | "INCOMPATIBLE_PLAN" | "INVALID_ACCESS" | "INVALID_SEGMENT" | "LINE_ALREADY_PRESENT_IN_CART" | "PREPAID_LINE";
export type IfpAccountSelectorQuery$variables = {
  cartId?: string | null;
  channel: CartChannel;
  deviceOfferId: string;
  ifpOfferId: string;
};
export type IfpAccountSelectorQuery$data = {
  readonly me: {
    readonly ifpEligibility: {
      readonly accounts: ReadonlyArray<{
        readonly accountNumber: string | null;
        readonly accountName: string | null;
        readonly isEligible: boolean | null;
      }>;
      readonly eligibleLines: ReadonlyArray<{
        readonly accountNumber: string | null;
        readonly accountName: string | null;
        readonly lineNumber: string;
        readonly offerId: string;
        readonly offerName: string;
      }>;
      readonly ineligibleLines: ReadonlyArray<{
        readonly accountNumber: string | null;
        readonly accountName: string | null;
        readonly lineNumber: string;
        readonly offerId: string;
        readonly offerName: string;
        readonly reason: IfpIneligibleLineReason | null;
      }>;
    };
  };
};
export type IfpAccountSelectorQuery = {
  variables: IfpAccountSelectorQuery$variables;
  response: IfpAccountSelectorQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cartId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "channel"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deviceOfferId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ifpOfferId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lineNumber",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerName",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "cartId",
            "variableName": "cartId"
          },
          {
            "kind": "Variable",
            "name": "channel",
            "variableName": "channel"
          },
          {
            "kind": "Variable",
            "name": "deviceOfferId",
            "variableName": "deviceOfferId"
          },
          {
            "kind": "Variable",
            "name": "ifpOfferId",
            "variableName": "ifpOfferId"
          }
        ],
        "concreteType": "IfpEligibility",
        "kind": "LinkedField",
        "name": "ifpEligibility",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ifpEligibilityAccount",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isEligible",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IfpEligibleLine",
            "kind": "LinkedField",
            "name": "eligibleLines",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IfpIneligibleLine",
            "kind": "LinkedField",
            "name": "ineligibleLines",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reason",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IfpAccountSelectorQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IfpAccountSelectorQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "cffc4f6e1ca40b5632b912ccc5cbab80",
    "id": null,
    "metadata": {},
    "name": "IfpAccountSelectorQuery",
    "operationKind": "query",
    "text": "query IfpAccountSelectorQuery(\n  $cartId: String\n  $channel: CartChannel!\n  $deviceOfferId: String!\n  $ifpOfferId: String!\n) {\n  me {\n    ifpEligibility(cartId: $cartId, channel: $channel, deviceOfferId: $deviceOfferId, ifpOfferId: $ifpOfferId) {\n      accounts {\n        accountNumber\n        accountName\n        isEligible\n      }\n      eligibleLines {\n        accountNumber\n        accountName\n        lineNumber\n        offerId\n        offerName\n      }\n      ineligibleLines {\n        accountNumber\n        accountName\n        lineNumber\n        offerId\n        offerName\n        reason\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0167e8051c8b4f1d2194e0e5ae89e824";

export default node;
